
import { useMemo } from "react";
import { calculateDealerPrice, GoldPurity, getPurityMultiplier } from "@/lib/pricing";
import { useStore } from "@/store/useStore";
import { MetalPrice } from "@/lib/metal-price";

export function useDealerPrice(
  rawGoldPrice: MetalPrice | null,
  goldPurity: GoldPurity,
  buySpread?: number | null
) {
  // Memoize purity multiplier calculation with cache
  const purityMultiplier = useMemo(() => {
    return getPurityMultiplier('ORO', String(goldPurity) as GoldPurity);
  }, [goldPurity]);

  // Memoize market price calculation
  const marketPrice = useMemo(() => {
    if (!rawGoldPrice || typeof rawGoldPrice.price !== 'number') {
      return 0;
    }
    return rawGoldPrice.price * purityMultiplier;
  }, [rawGoldPrice, purityMultiplier]);

  // Memoize dealer buy price calculation
  const dealerBuyPrice = useMemo(() => {
    if (marketPrice === 0) {
      return 0;
    }
    
    if (buySpread !== null && buySpread !== undefined && !isNaN(buySpread)) {
      return calculateDealerPrice(marketPrice, buySpread);
    }
    
    return marketPrice; // Return market price if spread is not applicable
  }, [marketPrice, buySpread]);

  console.log(`useDealerPrice OPTIMIZED - rawPrice=${rawGoldPrice?.price}, purity=${String(goldPurity)}, multiplier=${purityMultiplier}, marketPrice=${marketPrice}, spread=${buySpread}`);

  return { marketPrice, dealerBuyPrice };
}
